import './App.css';
import Home from './pages/home/home';

function App() {
  return (
    <div className="App">       
     
      <div className='content_container'>
        <Home></Home>      
      </div>     

 
    </div>
  );
}

export default App;
